module.exports = __webpack_public_path__ + "img/H1.63909125.png";